import { useSelector } from 'react-redux';
import { selectAppId } from 'store/v1/auth/auth.selectors';
import { Booking } from '__types__';
import { myServices } from 'v5/services/services.connected.app';

function useAssignedProductions(booking: Booking) {
  const app_id = useSelector(selectAppId);
  const productionIds =
    booking.resource_slot_assignments?.flatMap(
      assignment => assignment?.resource_slot?.production_id ?? []
    ) ?? [];

  return myServices.productionService.useProductionsById(
    app_id ?? '',
    productionIds
  );
}

interface ResourceStatusDropdownContentProps {
  booking: Booking;
  children: (
    productionsQuery: ReturnType<typeof useAssignedProductions>
  ) => React.ReactNode;
}

export function ResourceStatusDropdownContent({
  booking,
  children
}: ResourceStatusDropdownContentProps) {
  const productionsQuery = useAssignedProductions(booking);

  return <>{children(productionsQuery)}</>;
}
